import type { ConnectedApiTableProps } from 'components/ConnectedApiTable/ConnectedApiTable';
import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { assoc, merge } from 'ramda';
import type { ComponentType, ReactElement } from 'react';

export type RoutesWithApiEndpoint = {
  [path: string]: {
    apiEndpoint: string;
    element: ReactElement;
    tableComponent?: ComponentType<ConnectedApiTableProps>;
  };
};

export const getRoutesWithApiEndpoint = (
  routes: RoutesTreeItem[],
  found: RoutesWithApiEndpoint,
): RoutesWithApiEndpoint => {
  return routes.reduce((acc: RoutesWithApiEndpoint, route: RoutesTreeItem) => {
    if (route.path && route.apiEndpoint) {
      return assoc(
        route.path,
        {
          apiEndpoint: route.apiEndpoint,
          element: route.element,
          tableComponent: route.tableComponent,
        },
        acc,
      ) as RoutesWithApiEndpoint;
    }
    if (route.children) {
      return merge(acc, getRoutesWithApiEndpoint(route.children, acc));
    }
    return acc;
  }, found);
};
